import { render } from "./btn-group-schedule.vue?vue&type=template&id=02331f64&ts=true"
import script from "./btn-group-schedule.component.ts?vue&type=script&lang=ts"
export * from "./btn-group-schedule.component.ts?vue&type=script&lang=ts"

import exportComponent from "D:\\trainsit project\\LTMS\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__